import React, { useRef, useState } from "react";
import Style from "./FailedPayTabel.module.scss";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Check2, PencilSquare, Wallet, XLg } from "react-bootstrap-icons";
import { userTypeEnum } from "../../../../Utils/Helper/Helper";
import { recalculatePaymentApi } from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";

const FailedPayTabel = ({ showAddress, data, updateList }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [loadingState, setLoadingState] = useState(false);
  const reCalculateHandler = (value) => {
    setLoadingState(true);
    const info = {
      order_id: value?.order_id,
      user_type: value?.type,
      user_id: value.userId,
    };
    recalculatePaymentApi(info, (succ, res) => {
      if (succ) {
        setLoadingState(false);
        if (res.status === 1) {
          succToast("با موفقیت محسابه انجام شد!");
          updateList();
        } else {
          errorToast(res.message);
        }
      } else {
        setLoadingState(false);
        console.error(res);
      }
    });
  };
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "شماره سفارش",
      dataIndex: "order_id",
      key: "order_id",
      sorter: (a, b) => parseInt(a.order_id) - parseInt(b.order_id),
    },
    {
      title: " نام کاربری",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name", "نام "),
    },
    {
      title: "شناسه کاربر",
      dataIndex: "userId",
      key: "userId",
      ...getColumnSearchProps("userId", "شناسه کاربر"),
    },
    {
      title: "نوع کاربر",
      dataIndex: "type",
      key: "type",
      ...getColumnSearchProps("type", "شناسه کاربر"),
      render: (item) => <p>{userTypeEnum[item]}</p>,
    },
    {
      title: "عملیات",
      dataIndex: "operation",
      key: "operation",
      render: (item, listData) => (
        <Button
          type="primary"
          onClick={() => reCalculateHandler(listData)}
          loading={loadingState}
          disabled={loadingState}
        >
          محاسبه مجدد
        </Button>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ showSizeChanger: true }}
        columns={columns}
        dataSource={data}
        responsive={true}
      />
    </div>
  );
};

export default FailedPayTabel;
